module.exports = __webpack_public_path__ + "img/user_bg.1121f356.png";